module.exports = __webpack_public_path__ + "img/events.5d1e3e99.svg";